import { useFetchQuery } from "./useQueries";

const usePermission = ({ role }: { role?: string }) => {
  const { data, isLoading: permissionLoading } = useFetchQuery({
    key: ["FETCH_ALL_PERMISSION"],
    route: "/permissions/",
    requestBody: { role },
  });

  return {
    permissions: data?.data?.data,
    permissionLoading,
  };
};

export default usePermission;
